import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'ghost' | 'link';
  busy?: boolean;
}

export function Button({
  children,
  variant = 'primary',
  busy,
  disabled,
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      className={`btn btn-${variant}`}
      type={type}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      {...rest}
    >
      {children}
    </button>
  );
}
